import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Serenia_Residences.webp';

const Project_fiveteen = () => {

  return (
     <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Serenia Residences</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>A premium residential development on Palm Jumeirah comprising luxury apartments and penthouses with direct beachfront
                      access and panoramic Arabian Gulf views. Positioned as one of the Palm's most refined residential addresses.</p>
                  <p>MAIN CONTRACTOR : Khansaheb</p>
                  <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                  <p>GEMCO SCOPE OF WORKS : Complete CHW scope and partial electrical works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>
  )
}

export default Project_fiveteen